import { ScrollView, View } from 'react-native';
import React, { useCallback } from 'react';
import type { CheckoutSuccessPage } from '../../types';
import { Button, Text } from '~/components';
import { SUCCESS_PAGE_WIDTH } from '../../index.web';
import useAppNavigation from '~/hooks/useAppNavigation';

interface Props extends CheckoutSuccessPage {
  isLastPage: boolean;
}

const Page = ({ image: Image, text, footer, isLastPage }: Props) => {
  const { navigate } = useAppNavigation();

  const RenderContainer: any = useCallback(
    ({ children }: { children: React.ReactNode }) => {
      if (isLastPage) {
        return (
          <ScrollView
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {children}
          </ScrollView>
        );
      }

      return children;
    },
    [isLastPage]
  );

  return (
    <View
      className={`items-center justify-center w-[${SUCCESS_PAGE_WIDTH}px] pt-20`}
    >
      <RenderContainer>
        <Image />

        <View className="items-center mt-8 px-11">
          <Text className="text-center text-xl max-w-[250px]">{text}</Text>
        </View>

        <View className="justify-end flex-1 w-[328px]">{footer}</View>
      </RenderContainer>

      {isLastPage && (
        <View className="w-[300px] justify-end mt-12">
          <Button onPress={() => navigate('MarisaServicos_Home')}>
            Voltar para a home
          </Button>
        </View>
      )}
    </View>
  );
};

export default Page;
